import { useEffect, useState } from "react";
import fetchData from "../utils/fetchData";
import { errorMessage } from "../utils/errorMessage";

export function useSaveFingerPrintInDatabase(visitorId, user, errMessage) {
  const [resultData, setResultData] = useState(() => {
    const saved = sessionStorage.getItem("resultData");

    if (!saved || saved === "undefined" || saved === "null") {
      sessionStorage.removeItem("resultData");
      return null;
    }

    try {
      return JSON.parse(saved);
    } catch {
      sessionStorage.removeItem("resultData");
      return null;
    }
  });

  const [retryCount, setRetryCount] = useState(1);
  const [errorsMessage, setErrorsMessage] = useState(null);

  const MAX_RETRY_ATTEMPTS = 3;
  const RETRY_INTERVAL_MS = 30000;

  async function fetch(fingerPrint) {
    try {
      const { resultData } = await fetchData(
        "POST",
        "/api/userIdentification/createUserIdentification",
        fingerPrint,
      );

      if (resultData !== undefined && resultData !== null) {
        setResultData(resultData);
        sessionStorage.setItem("resultData", JSON.stringify(resultData));
      }
      setErrorsMessage(null);
    } catch (error) {
      const { message } = errorMessage(error);
      setErrorsMessage(message);
      console.log(
        `Failed to save visitorId. Retrying (${retryCount}/${MAX_RETRY_ATTEMPTS})...`,
      );
      setRetryCount((prev) => prev + 1); // ✅ avoid stale state
    }
  }

  useEffect(() => {
    if (!visitorId) return;

    // ✅ if we already saved for this visitorId, don't resave
    const saved = sessionStorage.getItem("resultData");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (
          parsed?.visitorId === visitorId ||
          parsed?.fingerPrint?.visitorId === visitorId
        ) {
          return;
        }
      } catch (e) {
        // ignore parse errors, will re-save
      }
    }

    let timeoutId;

    const visitTimeFromSession = sessionStorage.getItem("visitTime");
    const firstVisitTime = visitTimeFromSession
      ? Number(visitTimeFromSession)
      : Date.now();

    const fingerPrint = {
      visitorId,
      firstVisitTime,
      registeredUserId: user?._id,
      errMessage: errorsMessage || errMessage,
    };

    if (retryCount === 1) {
      fetch(fingerPrint);
    } else if (retryCount <= MAX_RETRY_ATTEMPTS) {
      timeoutId = setTimeout(() => {
        fetch(fingerPrint);
      }, RETRY_INTERVAL_MS);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId); // ✅ cleanup
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visitorId, retryCount, user?._id]);

  return resultData;
}
